<template>
<b-card tag="footer" class="rounded-0 text-white text-center text-lg-left" border-variant="transparent" bg-variant="black" footer-class="border border-light border-1 border-left-0 border-right-0 border-bottom-0">
    
    <div class="container">
        <div class="row mt-4 pt-2">

            <div class="col-lg-3">
                <b-img src="/wp-content/themes/rhiza/dist/assets/logo-losango.png" alt="bauhaus" class="mb-5 tamanho-imagem-footer"/>

                <!-- <div class=" mt-4 h5 m-0 bold">
                    <a :href="fb">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/fb_icon.png" alt="Facebook" class="mb-5 "/>
                    </a>

                    <a :href="insta">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/insta_icon.png" alt="Instagram" class="mb-5 ml-4"/>
                    </a>
                </div> -->
            </div>

            <div class="col-6 col-lg-3">
                <h6 class="font-glacial-bold mb-4" style="font-size: 18px">
                    Institucional
                </h6>
                
                <ul class="list-unstyled pt-2" v-if="pages">
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/">
                            Home
                        </b-link>
                    </li>

                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/bauhaus">
                            Bauhaus
                        </b-link>
                    </li>

                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/blog">
                            Blog
                        </b-link>
                    </li>

                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/videos">
                            Vídeos
                        </b-link>
                    </li>

                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/eventos">
                            Eventos
                        </b-link>
                    </li>
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/concurso-de-bolsas" v-if="concursoDate">
                            Concurso de bolsas
                        </b-link>
                    </li>

                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/unifran">
                            Unifran
                        </b-link>
                    </li>
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" to="/autores">
                            Autores
                        </b-link>
                    </li>
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/politica-de-privacidade'">
                            Política de Privacidade
                        </b-link>
                    </li>
                </ul>
            </div>

            <div class="col-6 col-lg-3">
                <h6 class="font-glacial-bold mb-4" style="font-size: 18px">
                    Cursos
                </h6>
                
                <ul class="list-unstyled pt-2">
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/design-de-interiores'">
                            Design de interiores
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/arquitetura'">
                            Arquitetura
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/desenho'">
                            Desenho
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/marketing'">
                            Marketing
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/linguas'">
                            Línguas
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/design-digital'">
                            Design digital
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/artes-integradas'">
                            Artes integradas
                        </b-link>
                    </li>
                    
                    <li class="mb-3">
                        <b-link router-tag="a" class="font-white font-glacial-regular" :to="'/cursos/informatica'">
                            Informática
                        </b-link>
                    </li>
                </ul>
            </div>

            <div class="col-lg-3 link-google-maps">
                <div class="contato lh-1">
                    <h6 class="font-glacial-bold mb-2 mb-xl-4 pb-1 mt-sm-0 mt-4" style="font-size: 18px">
                        Contato
                    </h6>
                    <a href="https://www.google.com/maps/place/Bauhaus+Brasil+-+Centro+de+Forma%C3%A7%C3%A3o+Profissional/@-21.1741163,-47.8092348,17z/data=!4m13!1m7!3m6!1s0x94b9befea31f8069:0x3ec8525a1307413f!2sR.+Mariana+Junqueira,+623+-+Centro,+Ribeir%C3%A3o+Preto+-+SP,+14015-010!3b1!8m2!3d-21.1741163!4d-47.8070461!3m4!1s0x94b9befea38359ad:0xd25ac090dbda84dd!8m2!3d-21.1742953!4d-47.8072033" target="_blank">
                        <p class="mt-2 m-0 pt-2" v-html="'Escola Bauhaus Brasil'"></p>
                        <p class="mt-2 m-0" v-html="'R. Mariana Junqueira, 623 - Centro'"></p>
                        <p class="mt-2 m-0 mb-4" v-html="'Ribeirão Preto - SP'"></p>
                        <span class="h5 font-glacial-bold">16 <span class="h4 font-glacial-bold"><a href="tel:16-3636-9291">3636-9291</a></span></span>
                    </a>
                    <a :href="fbRP" target="_blank">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/fb_icon.png" alt="Facebook" class="mx-2 mb-2" style="width:40px"/>
                    </a>
                    <a :href="instaRP" target="_blank">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/insta_icon.png" alt="Instagram" class="mb-2" style="width:40px"/>
                    </a>
                </div>
                <div class="contato lh-1 mt-4">
                    <a href="https://www.google.com/maps/place/Escola+Bauhaus+Brasil+Piracicaba/@-22.721263,-47.6448798,17z/data=!4m13!1m7!3m6!1s0x94c631a12567fe59:0x1d1179271aab648b!2sR.+Jos%C3%A9+Pinto+de+Almeida,+258+-+Alto,+Piracicaba+-+SP,+13419-000!3b1!8m2!3d-22.721263!4d-47.6426911!3m4!1s0x94c631a1256a71cf:0xf7a3b1d070af5f50!8m2!3d-22.721239!4d-47.64252" target="_blank">
                        <p class="mt-2 m-0 pt-2" v-html="'Escola Bauhaus Brasil II'"></p>
                        <p class="mt-2 m-0" v-html="'R. José Pinto de Almeida, 258 - Bairro Alto'"></p>
                        <p class="mt-2 m-0 mb-4 pb-1" v-html="'Piracicaba - SP'"></p>
                        <span class="h5 font-glacial-bold">19 <span class="h4 font-glacial-bold"><a href="tel:19-3422-2023">3422-2023</a></span></span>
                    </a>
                    <a :href="fbPira" target="_blank">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/fb_icon.png" alt="Facebook" class="mx-2 mb-2" style="width:40px"/>
                    </a>
                    <a :href="instaPira" target="_blank">
                        <b-img src="/wp-content/themes/rhiza/dist/assets/insta_icon.png" alt="Instagram" class="mb-2" style="width:40px"/>
                    </a>
                </div>                
            </div>
        </div>
    </div>
    
    <template slot="footer" >
        <div class="container">
            <div class="row">

                <div class="col-xl-6">
                    <span class="text-color-footer font-glacial-regular">Copyright 2018 </span>
                    <span class="font-glacial-bold">Escola Bauhaus Brasil.</span> 
                    <span class="text-color-footer font-glacial-regular">Todos os direitos reservados.</span>
                </div>

                <div class="col-xl-6 text-center text-lg-right text-color-footer">
                    Desenvolvido por: 
                    <b-img src="/wp-content/themes/rhiza/dist/assets/logo_mmt.png" alt="MMT" />
                </div>
            </div>
        </div>
    </template>
</b-card>
</template>

<script>
export default {
    
    data() {
        return {
            fbPira: 'https://www.facebook.com/bauhausbrasilpiracicaba/',
            instaPira: 'https://www.instagram.com/bauhauspiracicaba/',
            fbRP:'https://www.facebook.com/BauhausBrasil/',
            instaRP:'https://www.instagram.com/bauhausbrasilrp/',
        }
    },
    computed:{
        concursoDate(){
            var month = moment().month()

            if(month == 0 || month == 6){
                return true
            } else {
                return false
            }
        },

        fb(){
            return this.$store.state.hub.fb_link
        },

        insta(){
            return this.$store.state.hub.insta_link
        },
        
        pages(){
            return this.$store.state.page.all
        },

        ddd(){
            return this.$store.state.hub.ddd
        },

        telefone(){
            return this.$store.state.hub.telefone
        },

        site(){
            return this.$store.state.hub.site
        }
    },
}
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue